import React from "react";
import "./Paragraph.scss";

const Paragraph = ({ children, maxWidth }) => {
  return (
    <div className="arc-paragraph-wrapper">
      <p className="arc-paragraph-text"  style={{ maxWidth: maxWidth || "70%", whiteSpace: "pre-wrap" }}>{children}</p>
    </div>
  );
};

export default Paragraph;
